/** Pictures of email HTML in a locked sandbox; see email-sample.ts (ADR-0026, ADR-0039). */
import { previewDocument, sampleFill } from "./email-sample";

// --- Components --------------------------------------------------------------------------
export function SandboxedPreview({ html, title, className }: { html: string; title: string; className?: string }) {
  return (
    <iframe
      title={title}
      sandbox=""
      referrerPolicy="no-referrer"
      srcDoc={previewDocument(html)}
      className={className ?? "h-[28rem] w-full rounded-md border border-slate-200 bg-white"}
    />
  );
}

/**
 * A small, non-interactive picture of a template: the 600 px email drawn at half
 * size, with sample values in place of the variables. Without HTML, its text.
 */
export function EmailThumbnail({ html, text, title }: { html?: string | null; text?: string | null; title: string }) {
  if (html) {
    return (
      <div className="relative h-48 overflow-hidden border-b border-slate-200 bg-white" aria-hidden="true">
        <iframe
          title={title}
          sandbox=""
          referrerPolicy="no-referrer"
          loading="lazy"
          tabIndex={-1}
          srcDoc={previewDocument(sampleFill(html))}
          className="pointer-events-none absolute top-0 left-0 h-[24rem] w-[200%] origin-top-left scale-50 border-0"
        />
      </div>
    );
  }
  return (
    <div className="h-48 overflow-hidden border-b border-slate-200 bg-slate-50 p-4" aria-hidden="true">
      <p className="text-xs whitespace-pre-line text-slate-500">{text ? sampleFill(text) : "No content yet"}</p>
    </div>
  );
}
